module.exports = __webpack_public_path__ + "img/jaoc_pizzagame_black-crust.dd39d7b6.png";